import { useState, useRef, useEffect } from "react";
import { ArrowLeft, Save } from "lucide-react";
import { useNavigate } from "react-router-dom";
import SalesPaymentModal from "./pharmacymodels/SalesPaymentModal";
import SalesMedicineReminder from "./pharmacymodels/SalesMedicineReminder";
import { BranchPickerModal } from "./pharmacymodels/BranchPickerModal";
import PatientSelectionModal from '../pharmacy/PatientSelectionModal';
import DoctorSelectModal from "./pharmacymodels/DoctorSelectModal";
import DoctorFormModal from "./pharmacymodels/DoctorFormModal";
import { useFormik } from "formik";
import SelectProductName from "./SelectProductName";
import SaleInvoiceProductTable from "./SaleInvoiceProductTable";
import ProductSelectModal from "./pharmacymodels/ProductSelectModal";
import { useAddSaleMutation } from "../../State/Api/PharmacySaleApiSlice";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";

const AddSaleInvoice = () => {
const navigate = useNavigate();
const [showProductPicker, setShowProductPicker] = useState(false);
const [selectedProduct, setSelectedProduct] = useState(null);
const [isBatchModalOpen, setIsBatchModalOpen] = useState(false);
const [showProductModal, setShowProductModal] = useState(false);
const [patientModal, setPatientModal] = useState(false);
const [selectedPatient, setSelectedPatient] = useState(null);
const [addSale] = useAddSaleMutation();
const location = useLocation();
const editData = location.state;      // will be undefined in Add mode
const isEdit = editData?.id ? true : false;
const [products, setProducts] = useState([]);
const [showPay, setShowPay] = useState(false);

const [newProduct, setNewProduct] = useState({
  productBarcode: "",
  prodID: "",
  hsNorSAC: "",
  rx: "",
  batchID: "",
  expiry: "",
  pack: "1 x",
  numOfPacks: "",
  loose: 0,
  mrp: "",
  rate: "",
  discPer: "",
  gstPer: "",
  marginPer: "",
  amount: 0,
  billID: 0,
  billProdID: 0,
  invoiceID: "",
  isActive: true,
  location: "",
  pharmaID: ""
});

const handleChange = (e) => {
  console.log(e.target.value);
  const { name, value } = e.target;
  formik.setFieldValue("salesType", value);
  formik.setFieldValue("salesType", value);
};



  const handleSavePayment = (payload) => {
    // TODO: send to API / merge into invoice state
    console.log('Payment payload:', payload);
    setShowPay(false);
  };

  const [openBranchModal, setOpenBranchModal] = useState(false);
  const branchInputRef = useRef(null);

  // Example dataset (replace with live data)
  const branches = [
    { id: 1, name: "Main Clinic", address: "MG Road, Pune", nature: "Retail", drugLic: "DL-1234", balance: "₹0", mobile: "9876543210" },
    { id: 2, name: "South Hub", address: "Adyar, Chennai", nature: "Wholesale", drugLic: "DL-5678", balance: "₹12,500", mobile: "9123456780" },
  ];

  const [selectOpen, setSelectOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [showCreateProductModal, setShowCreateProductModal] = useState(false);
  const districts = ["Visakhapatnam", "Vijayawada", "Hyderabad"];
  const [totalAmount, setTotalAmount] = useState(0);
  const handleCreate = () => { setEditing(null); setFormOpen(true); };
  const handleEdit = (id) => { setEditing(doctors.find(d => d.id === id)); setFormOpen(true); };
  const handleDelete = (id) => setDoctors(prev => prev.filter(d => d.id !== id));
 
  const saleInvoiceSchema = Yup.object().shape({
    invoiceId: Yup.string().trim().required("This field is required"),
    salesType: Yup.string().trim().required("Sales Type is required"),
    dateOfSale: Yup.date().typeError("Invalid date").required("Sale Date is required"),
    patientName: Yup.string().trim().required("Patient Name is required"),
    doctorName: Yup.string().trim().required("Doctor Name is required"),
    products: Yup.array()
      .of(
        Yup.object().shape({
          prodID: Yup.mixed().required("Product ID is required"),
          batchID: Yup.string().required("Batch is required"),
          hsNorSAC: Yup.string().required("HSN is required"),
          pack: Yup.string().required("Pack is required"),
          expiry: Yup.string().required("Expiry is required"),
          mrp: Yup.number().typeError("MRP must be a number").positive("MRP must be > 0").required("MRP is required"),
          numOfPacks: Yup.number().typeError("Packs must be a number").positive("Packs must be > 0").required("No. of Packs is required"),
          rate: Yup.number().typeError("Rate must be a number").positive("Rate must be > 0").required("Rate is required"),
          discPer: Yup.number().typeError("Discount must be a number").min(0, "Discount cannot be negative").required("Discount % is required"),
          gstPer: Yup.number().typeError("GST must be a number").min(0, "GST cannot be negative").required("GST % is required"),
          marginPer: Yup.number().typeError("Margin must be a number").required("Margin % is required"),
        })
      )
      .min(1, "At least one product is required")
      .required("Products cannot be empty"),
  });

  const formik = useFormik({
    initialValues: {
  "billId": 0,
  "pharmaId": localStorage.getItem("userUniqueID"),
  "invoiceId": "",
  "salesType": "",
  "deliveryType": "",
  "dateOfSale": "",
  "customerId": selectedPatient?.patientID || 0,
  "patientName": selectedPatient?.patientName || "",
  "doctorName": "",
  "totalBillDiscPercent": 0,
  "totalBillDiscount": 0,
  "totalBill": parseInt(totalAmount),
  "billAfterDisc": 0,
  "numberOfProducts": products.length,
  "extraCharge": 0,
  "extraChargeDesc": "",
  "paymentType": "",
  "fullyPaid": true,
  "paidAmount": 0,
  "isActive": true,
  "createdBy": "",
  "updatedBy": "",
  "products": []
},
enableReinitialize: true,
validationSchema: saleInvoiceSchema,
onSubmit: async (values) => {
  console.log("Invoice Data:", {...values, products : products});
  const modProducts = products.map(product => {
    const newObj = {...product, pharmaID: localStorage.getItem("userUniqueID"), invoiceID: values.invoiceId};
    delete newObj.productBarcode;
    delete newObj.id;
    return newObj;
}
);
  const result = await addSale({...values, products : modProducts}).unwrap();
}
  })

   const handleSave = (doc) => {
    formik.setFieldValue("doctorName", doc.name);
    setFormOpen(false);
    setSelectOpen(true);
  };

    const handleProductName = (product) => {
      debugger;
      console.log(product);
    setNewProduct((prev)=>({...prev, prodID: product.productID, productBarcode: product.productName}));
    setSelectedProduct(product.productName);
    setShowProductPicker(false);
    //setIsBatchModalOpen(true);
};


const computeNormalizedForProduct = (product = {}) => {
  // normalize input fields (support your field names)
  const packs = parseFloat(product.numOfPacks ?? product.packs) || 0;
  const loose = parseFloat(product.loose) || 0;
  const mrp = parseFloat(product.mrp) || 0; // mrp may be pack price or unit price
  const disc = parseFloat(product.discPer ?? product.disc) || 0;
  const gst = parseFloat(product.gst) || 0;
  const unitsPerPack = parseFloat(product.unitsPerPack ?? product.pack) || 0;

  // determine unit price for loose items
  const unitPrice = unitsPerPack > 0 ? mrp / unitsPerPack : mrp;

  // compute gross from packs and loose
  const grossPacks = packs * mrp;
  const grossLoose = loose * unitPrice;
  const gross = grossPacks + grossLoose;

  // apply line discount and gst
  const discountAmt = (gross * disc) / 100;
  const taxable = gross - discountAmt;
  const gstAmount = (taxable * gst) / 100;
  const lineTotal = Number((taxable + gstAmount).toFixed(2));

  return {
    packs,
    loose,
    unitsPerPack,
    mrp,
    unitPrice: Number(unitPrice.toFixed(4)),
    gross: Number(gross.toFixed(2)),
    discountAmt: Number(discountAmt.toFixed(2)),
    taxable: Number(taxable.toFixed(2)),
    gstAmount: Number(gstAmount.toFixed(2)),
    lineTotal,
  };
};

// ---------- calculate totals + lines (non-mutating) ----------
const calculateTotalAmount = (products = []) => {
  const lines = (products || []).map((product) => {
    const normalized = computeNormalizedForProduct(product);
    return {
      ...product,
      normalized,
    };
  });

  const subtotal = lines.reduce((s, l) => s + (parseFloat(l.normalized.lineTotal) || 0), 0);

  const billDiscountPercent = parseFloat(formik?.values?.totalBillDiscPercent) || 0;
  const billDiscountValue = parseFloat(formik?.values?.totalBillDiscount) || 0;

  const discount =
    billDiscountPercent > 0 ? (subtotal * billDiscountPercent) / 100 : billDiscountValue || 0;

  const finalTotal = Number((subtotal - discount).toFixed(2));

  return {
    lines, // each has .normalized with computed data (lineTotal etc.)
    subtotal: Number(subtotal.toFixed(2)),
    discount: Number(discount.toFixed(2)),
    total: finalTotal,
  };
};

// ---------- totals state ----------
const [totals, setTotals] = useState({
  lines: [],
  subtotal: 0.0,
  discount: 0.0,
  total: 0.0,
});


useEffect(() => {
  const products = formik?.values?.products || [];

  // compute normalized lines based on current products
  const computed = calculateTotalAmount(products);

  // prepare updatedProducts by copying and setting amount = lineTotal
  const updatedProducts = (products || []).map((p, idx) => {
    const computedLine = computed.lines[idx];
    const newAmount = computedLine ? computedLine.normalized.lineTotal : 0;
    // keep original value types for other keys
    return { ...p, amount: newAmount };
  });

  // Check if any amount differs from what's in formik — if so, update formik
  let shouldWriteBack = false;
  for (let i = 0; i < (products || []).length; i++) {
    const original = products[i] ?? {};
    const updated = updatedProducts[i] ?? {};
    const origAmt = parseFloat(original.amount) || 0;
    const newAmt = parseFloat(updated.amount) || 0;
    if (Math.abs(origAmt - newAmt) > 0.0001) {
      shouldWriteBack = true;
      break;
    }
  }

  if (shouldWriteBack && typeof formik.setFieldValue === "function") {
    // write back updated products to Formik (do not trigger immediate validation)
    formik.setFieldValue("products", updatedProducts, false);
    // after writeback, Formik's values will update and this effect will run again,
    // but the shouldWriteBack guard will usually prevent infinite loops.
  }

  // ALWAYS update local totals state (use updatedProducts to ensure totals reflect amounts)
  const totalsToSet = calculateTotalAmount(updatedProducts);
  setTotals(totalsToSet);
  // dependencies include products and invoice-level discount inputs so totals update reactively
}, [
  // watch products array reference and bill-level discounts
  formik.values.products,
  formik.values.totalBillDiscPercent,
  formik.values.totalBillDiscount,
]);


  const styles = `.add-new-purchase {
  background: #f5f5f5;
  min-height: 100vh;
  padding: 20px;

.table-input {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 6px 10px;
  outline: none;
  transition: background 0.3s ease, color 0.3s ease;
}

/* Expired: Red background */
.table-input.expired {
  background-color: #ffcccc;
  border-color: #ff4d4d;
  color: #a10000;
}

/* Future expiry: Orange background */
.table-input.future {
  background-color: #ffe6cc;
  border-color: #ffa500;
  color: #663c00;
}


.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.back-arrow {
  cursor: pointer;
  color: #666;
}

.header h1 {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.subtitle {
  color: #666;
  margin: 5px 0 0 0;
  font-size: 14px;
}

.header-right {
  display: flex;
  gap: 10px;
}

.watch-tutorial-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.save-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #5c6bc0;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.form-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.form-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-icon {
  color: #6c5ce7;
  margin-left: 5px;
  cursor: help;
}

.required {
  color: #e74c3c;
  font-size: 10px;
  font-weight: normal;
}

.radio-group {
  display: flex;
  gap: 15px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  cursor: pointer;
}

.radio-label input[type="radio"] {
  accent-color: #6c5ce7;
}

.form-input, .form-select {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #6c5ce7;
}

.date-input {
  position: relative;
}

.calendar-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  pointer-events: none;
}

.status-indicators {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-bottom: 10px;
}

.status-indicator {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-indicator.expired {
  background: #e74c3c;
  color: white;
}

.status-indicator.expiring {
  background: #f39c12;
  color: white;
}

.products-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.products-table table {
  width: 100%;
  border-collapse: collapse;
}

.products-table th {
  background: #f8f9fa;
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  font-size: 11px;
  color: #333;
  border-bottom: 2px solid #dee2e6;
  text-transform: uppercase;
}

.products-table td {
  padding: 12px 8px;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
}

.new-product-row {
  background: #f8f9fa;
}

.table-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  background: white;
}

.table-input:focus {
  outline: none;
  border-color: #6c5ce7;
}

.add-btn {
  background: #5c6bc0;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
}

.edit-all-btn {
  background: transparent;
  border: none;
  color: #6c5ce7;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  text-transform: uppercase;
}

.product-name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  font-size: 12px;
}

.status-dot.expired {
  color: #e74c3c;
}

.status-dot.expiring {
  color: #f39c12;
}

.expiry-warning {
  color: #f39c12;
  font-weight: 600;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.edit-icon, .delete-icon {
  cursor: pointer;
  color: #666;
}

.edit-icon {
  color: #6c5ce7;
}

.delete-icon {
  color: #e74c3c;
}

.bottom-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.discount-charge-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  gap: 20px;
}

.save-payment-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #666;
}

.totals-bar {
  background: #2c3e50;
  color: white;
  padding: 15px 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
}

.totals-left {
  display: flex;
  gap: 30px;
  font-size: 14px;
}

.totals-right {
  display: flex;
  gap: 20px;
  aign-items: center;
  font-size: 14px;
}

.total-amount {
  background: #2f9c59ff;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 16px;
}
  /* Add these additional styles to your existing CSS */

.save-edit-btn {
  background: #28a745;
  border: none;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cancel-edit-btn {
  background: #dc3545;
  border: none;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.edit-icon, .delete-icon {
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.edit-icon {
  color: #6c5ce7;
}

.edit-icon:hover {
  background-color: #f0f0f0;
}

.delete-icon {
  color: #e74c3c;
}

.delete-icon:hover {
  background-color: #ffebee;
}

.table-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  background: white;
}

.table-input:focus {
  outline: none;
  border-color: #6c5ce7;
  box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);
}

.product-row.editing {
  background-color: #f8f9fa;
}

 .scheme-input-container {
          display: flex;
          align-items: center;
          gap: 2px;
          background: white;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 2px 4px;
          font-size: 13px;
          min-width: 80px;
        }

        .scheme-input-container:focus-within {
          border-color: #6c5ce7;
          box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.2);
        }

        .scheme-base-input {
          border: none;
          outline: none;
          width: 30px;
          text-align: center;
          padding: 2px;
          background: transparent;
          font-size: 13px;
          color: #333;
        }

        .scheme-bonus-input {
          border: none;
          outline: none;
          width: 30px;
          text-align: center;
          padding: 2px;
          background: transparent;
          font-size: 13px;
          color: #333;
        }

        .scheme-display {
          display: flex;
          align-items: center;
          gap: 2px;
          font-size: 13px;
          color: #333;
          padding: 4px;
        }

        .scheme-percentage-display {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          color: #333;
          background: #f8f9fa;
          padding: 6px 8px;
          border-radius: 4px;
          border: 1px solid #e9ecef;
          min-width: 60px;
          font-weight: 500;
        }

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
  
  .save-edit-btn, .cancel-edit-btn {
    padding: 6px 10px;
  }
}


@media (max-width: 768px) {
  .add-new-purchase {
    padding: 10px;
  }
  
  .header {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .header-right {
    width: 100%;
    justify-content: flex-end;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .products-table {
    overflow-x: auto;
  }
  
  .bottom-section {
    grid-template-columns: 1fr;
  }
  
  .totals-bar {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
  
  .totals-left, .totals-right {
    flex-wrap: wrap;
    justify-content: center;
  }
}
`;

  return (
    <div className="add-new-purchase">
      <style>{styles}</style>
            <div className="header">
              <div className="header-left">
                <button type="button" onClick={() => navigate(-1)}>
                  <ArrowLeft className="back-arrow" size={24} />
                </button>
                <div>
                  <h1>{isEdit ? "Edit Sale Invoice" : "Sale Invoice"}</h1>

                </div>
              </div>
              <div className="header-right">
                <button
                  type="button"
                  onClick={formik.handleSubmit}
                  className="gradient-button"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Save size={16} /> Saving
                </button>
              </div>
            </div>
    <form onSubmit={formik.handleSubmit}>
    <div className="p-6 bg-gray-50 min-h-screen bg-[#f5f5f5]">
      {/* Header */}


      {/* Invoice Info */}
      <div className="bg-white p-3 rounded-xl shadow-sm mb-5">
        <div className="flex w-full gap-4">
          {/* Sale Type */}
          <div>
            <label className="text-[12px] text-gray-600">SALE TYPE</label>
            <div className="flex gap-4 mt-2">
              {["Sale Invoice"].map((type) => (
                <label
                  key={type}
                  className="flex items-center gap-2 text-gray-700 cursor-pointer text-[12px]"
                >
                  <input
                    type="radio"
                    name="salesType"
                    value={type}
                    checked={formik.values.salesType === type}
                    onChange={handleChange}
                    className="peer h-4 w-4 text-cyan-600 focus:ring-cyan-500"
                  />
                  {type}
                  {formik.touched.salesType && formik.errors.salesType && (
                  <div className="text-red-500 text-xs mt-1">{formik.errors.salesType}</div>
                )}
                </label>
              ))}
              
            </div>
          </div>
          

          {formik.values.salesType !== "Branch Transfer" && <>{/* Document No */}
          <div className="w-[13%]">
            <label className="flex items-center gap-2 text-gray-700 cursor-pointer text-[12px]">DOCUMENT NO</label>
            <input
              type="text"
              name="invoiceId"
              value={formik.values.invoiceId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="w-full mt-2 border rounded-lg px-3 py-2 text-[12px]"
              placeholder="Sale Invoice"
            />
            {formik.touched.invoiceId && formik.errors.invoiceId && (
                    <div className="text-red-500 text-xs mt-1">{formik.errors.invoiceId}</div>
                  )}
          </div>

          {/* Sale Date */}
          <div className="w-[13%]">
            <label className="flex items-center gap-2 text-gray-700 cursor-pointer text-[12px]">SALE DATE*</label>
            <input
              type="date"
              name="dateOfSale"
              value={formik.values.dateOfSale}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="w-full mt-2 border rounded-lg px-3 py-2 text-[12px]"
            />
            {formik.touched.dateOfSale && formik.errors.dateOfSale && (
                    <div className="text-red-500 text-xs mt-1">{formik.errors.dateOfSale}</div>
                  )}
          </div>
          {/* <div className="w-[13%]">
            <label className="flex items-center gap-2 text-gray-700 cursor-pointer text-[12px]">CUSTOMER*</label>
            <input
              type="text"
               name="customer"
    placeholder="Select customer"
    value={selectedCustomer?.name || formData.customer || ''}
    readOnly
    onClick={() => setShowCustomerPicker(true)}
              className="w-full mt-2 border rounded-lg px-3 py-2 text-[12px]"
            />
          </div> */}
          <div className="w-[20%]">
            <label className="flex items-center gap-2 text-gray-700 cursor-pointer text-[12px]">PATIENT*</label>
            <button
    onClick={() => setPatientModal(true)}
    type="button"
    style={{
      width: '100%',
      padding: '8px 16px',
      border: '2px solid #e5e7eb',
      borderRadius: '8px',
      fontSize: '14px',
      textAlign: 'left',
      background: selectedPatient ? '#f0fdf4' : '#fff',
      cursor: 'pointer',
      color: selectedPatient ? '#1f2937' : '#999',
      fontWeight: selectedPatient ? 600 : 400,
    }}
    className="mt-2"
  >
    {selectedPatient ? selectedPatient.patientName : 'Select patient name'}
  </button>
  {formik.touched.patientName && formik.errors.patientName && (
                    <div className="text-red-500 text-xs mt-1">{formik.errors.patientName}</div>
                  )}
          </div>
          <div className="w-[13%]">
            <label className="flex items-center gap-2 text-gray-700 cursor-pointer text-[12px]">DOCTOR*</label>
            <input
              type="text"
              name="doctorName"
              value={formik.values.doctorName}
              onChange={handleChange}
              className="w-full mt-2 border rounded-lg px-3 py-2 text-[12px]"
              onClick={() => setSelectOpen(true)}
            />
            {formik.touched.doctorName && formik.errors.doctorName && (
                    <div className="text-red-500 text-xs mt-1">{formik.errors.doctorName}</div>
                  )}
          </div>
          </>}

          
        </div>
      </div>

      {/* Products Table */}
          <SaleInvoiceProductTable 
            products={products}
            setProducts={setProducts}
            newProduct={newProduct}
            setNewProduct={setNewProduct}
            onShowProductModal={() => setShowProductModal(true)}
            overallDiscountPercent={formik.values.overallDiscountPercent}
            setTotalAmount={setTotalAmount}
            formik={formik}
          />

      {/* Totals Section */}
      <div className="mt-6 grid grid-cols-3 gap-4">
        <div className="bg-white p-4 rounded-xl shadow">
          <h3 className="text-gray-600 font-medium mb-3">
            BILL DISCOUNT 
          </h3>
          <div className="grid grid-cols-2 gap-3">
            <input
              type="number"
              name="totalBillDiscPercent"
              value={formik.values.totalBillDiscPercent}
              onChange={formik.handleChange}
              className="border rounded-md px-2 py-1 text-sm"
              placeholder="% Enter here"
            />
            <input
              type="number"
              name="totalBillDiscount"
              value={formik.values.totalBillDiscount}
              onChange={formik.handleChange}
              className="border rounded-md px-2 py-1 text-sm"
              placeholder="₹ Enter here"
            />
          </div>
        </div>

        <SalesMedicineReminder products={products} setProducts={setProducts} />
      </div>
      <div className="mt-6">
        
      </div>

      {/* Total footer */}
      <div className="mt-6 bg-gray-800 text-white p-4 rounded-xl flex justify-between items-center">
        <span className="text-sm">
          Total Products: {products.length}
        </span>
        <span className="font-semibold text-lg">
          Total Amount: ₹{totalAmount}
        </span>
      </div>

      <SalesPaymentModal
      show={showPay}
      onHide={() => setShowPay(false)}
      onSave={handleSavePayment}
      defaultValues={{
      payingCustomer: '',
      invoiceNumber: 'Invoice/2',
      invoiceDate: new Date().toISOString().slice(0, 10),
      paymentType: 'PAID/CASH',
      amountPaid: '181'
      }}
      />


      <SelectProductName
      isOpen={showProductPicker}
      onClose={() => setShowProductPicker(false)}
      onSelectProductName={handleProductName}
      setIsModalOpen={setShowProductPicker}
      formik={formik}
      setSelectedProduct={setSelectedProduct}
      />

      <PatientSelectionModal
      open={patientModal}
      onClose={() => setPatientModal(false)}
      onSelect={setSelectedPatient}
      formik={formik}
      />

      <DoctorSelectModal
      open={selectOpen}
      onClose={() => setSelectOpen(false)}
      onCreateNew={() => { setSelectOpen(false); handleCreate(); }}
      onEditSelected={(id) => { setSelectOpen(false); handleEdit(id); }}
      onDeleteSelected={handleDelete}
      formik={formik}
      districts={districts}
      initialDistrict="Visakhapatnam"
      />

      <DoctorFormModal
      open={formOpen}
      onClose={() => setFormOpen(false)}
      onSave={handleSave}
      editingDoctor={editing}
      districts={districts}
      />

      <ProductSelectModal
      open={showProductModal}
      onClose={() => setShowProductModal(false)}
      onSelect={(product) => {
        console.log("Selected product:", product);
      setNewProduct((prev) => ({
      ...prev,
      prodID: product.productID,
      productBarcode: product.productName,
      rate: product.saleRate || "",
      mrp: product.mrp, 
      }));
      setShowProductModal(false);
      }}
      onCreateNew={() => {
      setShowProductModal(false);
      setShowCreateProductModal(true);
      }}
      />
    </div>
    </form>
    </div>
  );
};

export default AddSaleInvoice;
